import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 922B06B7-9C78-452C-AF29-79A47F0F6931
 * name emoticon-neutral
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-neutral.svg
 * tags
 * - Emoji 
 */
export const EmoticonNeutralIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,9.5A1.5,1.5 0 0,1 8.5,8A1.5,1.5 0 0,1 10,9.5A1.5,1.5 0 0,1 8.5,11A1.5,1.5 0 0,1 7,9.5M16,16H8V14H16V16M15.5,11A1.5,1.5 0 0,1 14,9.5A1.5,1.5 0 0,1 15.5,8A1.5,1.5 0 0,1 17,9.5A1.5,1.5 0 0,1 15.5,11Z" /></>, 'EmoticonNeutralIcon');
export default EmoticonNeutralIcon